/**
 * Formats jurisdiction options for cart operations.
 *
 * @param {Array<{value: string}>} jurisdictionOptions - The list of jurisdiction options to be processed.
 * @param {string} servicePricingUuid - The unique identifier for the service pricing.
 * @param {string} [serviceName] - The name of the service (for addition).
 * @param {string} [couponUuid] - The unique identifier for the coupon.
 * @returns {Array} - The list of items formatted for cart operations.
 */
export function formatOptionsForCart(
  jurisdictionOptions,
  servicePricingUuid,
  serviceName,
  couponUuid
) {
  return jurisdictionOptions?.map((option) => ({
    jurisdictionState: option.value,
    servicePricingUuid,
    ...(serviceName && { serviceName }),
    ...(couponUuid && { couponUuid })
  }));
}

/**
 * Identifies jurisdictions that have been removed from the selection.
 *
 * @param {Array} prevJurisdictions - The list of previously selected jurisdictions.
 * @param {Array} newJurisdictions - The list of currently selected jurisdictions.
 * @returns {Array} - The list of jurisdiction objects that have been removed.
 */
export function findRemovedJurisdictions(prevJurisdictions, newJurisdictions) {
  const newJurisdictionValues = new Set(
    newJurisdictions.map((option) => option?.value).filter(Boolean)
  );

  const removedJurisdictions = [];

  prevJurisdictions?.forEach((option) => {
    if (!newJurisdictionValues.has(option.value)) {
      removedJurisdictions.push(option);
    }
  });

  return removedJurisdictions;
}
